import React from 'react';

import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getEnabledStudyTypes, getStudyTypeText} from 'studies/TypedStudyUtils';
import FormGroup from 'ui-library/bs/FormGroup';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Menu from 'ui-library/menus/Menu';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

export interface StudyTypeOption {
  studyType: StudyType;
  name: string;
}

interface Props {
  displayName: string;
  selectedStudyType: StudyTypeOption | null;
  onChangeStudyType: (studyType: StudyTypeOption | null) => void;
}

function getStudyTypeOptions(): Array<{value: StudyTypeOption | null; name: string}> {
  const supportedStudyTypes: Array<StudyType> = getEnabledStudyTypes();
  return [
    {value: null, name: 'All'},
    ...supportedStudyTypes
      .map((studyType) => ({
        value: {studyType, name: getStudyTypeText(studyType)},
        name: getStudyTypeText(studyType),
      }))
      .sort((a, b) => a.name.localeCompare(b.name)),
  ];
}

export function StudyTypeSelector(props: Props): JSX.Element {
  const studyTypeOptions = getStudyTypeOptions();
  return (
    <FormGroup dataTestAttrs={{component: 'StudyTypeSelector', element: 'root'}}>
      <FieldLabel label="Study type" />
      <SelectDropdown
        displayName={props.displayName}
        menu={
          <SearchableMenu
            onSelect={props.onChangeStudyType}
            selectedValue={props.selectedStudyType}
            width={Menu.WIDTHS.MEDIUM}
            optionDatas={studyTypeOptions}
          />
        }
      />
    </FormGroup>
  );
}
